<template>
  <div class="page page-route-details">
    <!-- <h2 v-if="isFuture">Future Routes Detail</h2>
    <h2 v-else>Routes Detail</h2> -->

    <!-- alert notice for errors -->
    <div class="alert alert-danger alert-dismissible fade show" role="alert"
         v-if="!ajaxLoading && !routeDetails">
      <h5>No Route Details found!</h5>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <template v-if="routeDetails">

      <div class="page-content" :class="{ loading: ajaxLoading }">

        <h2>
          <span v-if="routeDetails.field_mode === 'Bus'" class="icon-icon-bus"></span>
          <span v-else-if="routeDetails.field_mode === 'Light Rail'" class="icon-icon-light-rail"></span>
          <span
            class="circle-route-name"
            :title="routeDetails.title + ' - ' + routeDetails.field_route_name"
            :style="{ 
              'margin-left' : '10px',
              'background-color': routeDetails.color,  
              'color': (routeDetails.color === '#29588C' || routeDetails.color === '#E4002B') ? '#fff' : '#000' 
            }">{{ routeDetails.field_route_name }}</span>       
        </h2>
        <!-- <h3 v-if="!isFuture">{{ routeDetails.field_old_endpoint.join(" - ") }}</h3> -->
        <h3 v-if="isFuture">{{ routeDetails.field_new_endpoint.join(" - ") }}</h3>

        <!-- <template v-if="isFuture">
        <h5 class="mt-4">Future Service</h5>
        <p v-html="routeDetails.body"></p>
        </template> -->

        <h5 class="mt-4">Service Hours</h5>
        <p v-if="!isFuture">
          <span class="day-label">Weekdays</span> {{ routeDetails.field_old_weekday_hours }} <br>
          <span class="day-label">Saturdays</span> {{ routeDetails.field_old_saturday_hours }} <br>
          <span class="day-label">Sundays</span> {{ routeDetails.field_old_sunday_hours }} <br>
        </p>
        <p v-if="isFuture">
          <span class="day-label">Weekdays</span> {{ routeDetails.field_new_weekday_hours }} <br>
          <span class="day-label">Saturdays</span> {{ routeDetails.field_new_saturday_hours }} <br>
          <span class="day-label">Sundays</span> {{ routeDetails.field_new_sunday_hours }} <br>
        </p>

        <h5 class="mt-4">Frequency</h5>
        <p v-if="!isFuture">
          <span class="day-label">Weekday Peak</span> {{ routeDetails.field_old_weekday_peak_frequency }}<br>
          <span class="day-label">Weekday Midday</span> {{ routeDetails.field_old_weekday_midday_frequen }}<br>
          <span class="day-label">Saturdays</span> {{ routeDetails.field_old_saturday_frequency }}<br>
          <span class="day-label">Sundays</span> {{ routeDetails.field_old_sunday_frequency }}<br>
        </p>
        <p v-if="isFuture">
          <span class="day-label">Weekday Peak</span> {{ routeDetails.field_new_weekday_peak_frequency }}<br>
          <span class="day-label">Weekday Midday</span> {{ routeDetails.field_new_weekday_midday_frequen }}<br>
          <span class="day-label">Saturdays</span> {{ routeDetails.field_new_saturday_frequency }}<br>
          <span class="day-label">Sundays</span> {{ routeDetails.field_new_sunday_frequency }}<br>
        </p>
        <h5 class="mt-4" v-if="routeDetails.field_improvement">Improvements</h5>
        <ul>
          <li v-for="(item, index) in routeDetails.field_improvement" :key="'improvement-' + index">
            {{ item }}
          </li>          
        </ul>

        <div class="url-links mt-4 mb-4">
          <a v-if="!isFuture" class="btn btn-light" :href="routeDetails.field_old_route_detail_url">View Schedules</a>
          <!-- <a v-if="isFuture" class="btn btn-light">Track Progress of Service Change</a> -->
          <a v-if="isFuture" class="btn btn-light" :href="routeDetails.field_new_route_detail_url">View Schedules</a>
        </div>

      </div>

      <div style="min-height:500px; position: relative; border:solid 0 #999">

        <div class="map-loading-notice" v-if="ajaxLoading">Loading...</div>

        <gmap-map
            ref="vuegmap"
            id="route-details-map"
            v-if="googleMapsReady"
            :center="mapSettings.START_LOCATION"
            :zoom="mapSettings.START_ZOOMLEVEL"
            :options="{ streetViewControl: false, scaleControl: true, clickableIcons: false, styles: mapsStyles }">

          <!-- GPS geolocation -->
          <gmap-marker
              v-if="geolocation.enabled"
              :position="geolocation.position"
              :icon="iconGPSCircle">
          </gmap-marker>

        </gmap-map>

      </div>

      <div class="page-content page-content full-width bg-primary mt-4 py-6 text-white" :class="{ loading: ajaxLoading }">
        <h3>Popular Destinations</h3>
        <div v-html="routeDetails.body || '-'"></div>
      </div>

    </template>



  </div>
</template>

<script>
// @ is an alias to /src
import { MAP as mapSettings } from '../config/'
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'
import mixinMap from '../mixins/map'

export default {
  name: 'view-route-details',
  components: {
  },
  props: ['routesData', 'isFuture'],
  mixins: [mixinCommon, mixinFilters, mixinMap],
  data () {
    return {
      googleMapsReady: false,
      highlightColour: '#C44C1C',
      inputAddedViaMap: false,
      noneHighlightColour: '#502059',
      mapSettings: mapSettings,
      routeShape: {}
    }
  },
  computed: {
    routeDetails () {
      if (this.$route.params.routeNo === 'undefined') {
        return false
      }
      let result = false
      for (let route in this.routesData) {
        this.routesData[route].field_route_name = (this.routesData[route].field_route_name) ? this.routesData[route].field_route_name : ''
        if (this.routesData[route].title === this.$route.params.routeNo || this.routesData[route].field_route_name.split(" ").join("-").toLowerCase() === this.$route.params.routeNo) {
          result = this.routesData[route];
          if (this.isFuture && result.field_new_route_color){
            result.color = result.field_new_route_color;
          } else if (!this.isFuture && result.field_old_route_color){
            result.color = result.field_old_route_color;
          }
        }
      }
      return result;
    },
    ajaxLoading () {
      let loadingKeys = this.$store.getters['routes/ajaxLoading'];
      let loading = false
      for (let key in loadingKeys) {
        if (loadingKeys[key]) {
          loading = true
        }
      }
      return loading
    },
    geolocation () {
      return this.$store.getters['geoLocation/response'];
    }
  },
  methods: {
    init () {
      console.log('Route Details - init...');
      if (this.routeDetails.field_mode === 'Bus') {
        this.loadBusRouteShape(this.$route.params.routeNo)
      } else if (this.routeDetails.field_mode === 'Light Rail') {
        this.loadLightRailRouteShape(this.routeDetails.title.split(" ").join("-").toLowerCase() || this.$route.params.routeNo)
      }
    },
    loadBusRouteShape (routeNo) {
      // let apiUrl = 'https://gis.vta.org/gis2/rest/services/Transit/Bus/MapServer/1/query' // old API feed
      // let apiUrl = 'https://gis.vta.org/gis2/rest/services/Marketing/TryVtaOrgRoutes/MapServer/0/query'
      let apiUrl = 'https://gis.vta.org/gis/rest/services/Transit/Update2019NTSPAugust2019_tryvtaorg/MapServer/0/query'

      let options = {
        f: 'geojson',
        where: 'GTFS_ID=\'' + routeNo + '\'',
        returnGeometry: true,
        outSR: '4326',
        datumTransformation: 'D_WGS_1984',
        outFields: '*'
      }
      this.$store.commit('routes/SET_AJAX_LOADING', { key: 'bus-routes', loading: true })
      let jqXHR = jQuery.getJSON(apiUrl, options, (json) => {
        this.$refs.vuegmap.$mapObject.data.addGeoJson(json);
        this.$refs.vuegmap.$mapObject.data.setStyle({
            geodesic: true,
            strokeColor: this.routeDetails.color || '#56B8E9',
            strokeWeight: 9,
            strokeOpacity: 0.7,
            fillOpacity: 0.6,
            zIndex: 3
          });
        this.setMapBounds();
      })
      .fail((jqXHR, textStatus, error) => {
        console.log('"loadRoutes" Request Failed: ' + textStatus + ', ' + error)
      })
      .always(() => {
        this.$store.commit('routes/SET_AJAX_LOADING', { key: 'bus-routes', loading: false })
      })
    },
    loadLightRailRouteShape (routeNo) {
      // let apiUrl = 'https://gis.vta.org/gis2/rest/services/Transit/VTA_Rail/MapServer/2/query'
      // let apiUrl = 'https://gis.vta.org/gis2/rest/services/Marketing/TryVtaOrgRoutes/MapServer/0/query'
      let apiUrl = 'https://gis.vta.org/gis/rest/services/Transit/Update2019NTSPAugust2019_tryvtaorg/MapServer/0/query'
      let options = {
        f: 'geojson',
        where: 'GTFS_ID=\'' + routeNo + '\'',
        // where: 'GTFS_ID=' + routeNo,
        returnGeometry: true,
        outSR: '4326',
        datumTransformation: 'D_WGS_1984',
        outFields: '*'
      }
      this.$store.commit('routes/SET_AJAX_LOADING', { key: 'lightrail-routes', loading: true })
      let jqXHR = jQuery.getJSON(apiUrl, options, (json) => {
        json.features.map((f, i) => {
          if (f.geometry.type === 'LineString') {
            f.geometry.coordinates = f.geometry.coordinates.map(c => {
              return c.slice(0,2)
            })
          } else if (f.geometry.type === 'MultiLineString') {
            f.geometry.coordinates = f.geometry.coordinates.map(c => {
              return c.map(d => {
                return d.slice(0,2)
              });
            })
          }
          return f;
        })
        window.tmap = this.$refs.vuegmap.$mapObject
        this.$refs.vuegmap.$mapObject.data.addGeoJson(json);
        this.$refs.vuegmap.$mapObject.data.setStyle({
            geodesic: true,
            strokeColor:  this.routeDetails.color || '#000000',
            strokeWeight: 12,
            strokeOpacity: 0.7,
            fillOpacity: 0.6,
            zIndex: 2
          });
        this.setMapBounds();
      })
      .fail(function (jqXHR, textStatus, error) {
        console.log('"loadRoutes" Request Failed: ' + textStatus + ', ' + error)
      })
      .always(() => {
        this.$store.commit('routes/SET_AJAX_LOADING', { key: 'lightrail-routes', loading: false })
      })
    },
    setMapBounds () {
      // recursive function
      function processPoints(geometry, callback, thisArg) {
        if (geometry instanceof google.maps.LatLng) {
          callback.call(thisArg, geometry);
        } else if (geometry instanceof google.maps.Data.Point) {
          callback.call(thisArg, geometry.get());
        } else {
          geometry.getArray().forEach(function(g) {
            processPoints(g, callback, thisArg);
          });
        }
      }
      VueGoogleMaps.loaded
        .then(() => {
          if (this.$refs.vuegmap) {
            let bounds = new google.maps.LatLngBounds();
            this.$refs.vuegmap.$mapObject.data.forEach(feature => {
              processPoints(feature.getGeometry(), bounds.extend, bounds);
              this.$refs.vuegmap.$mapObject.fitBounds(bounds);
            });
          }
        })
    },
  },
  mounted () {
    VueGoogleMaps.loaded
      .then(() => {
        this.googleMapsReady = true
        this.init()
      });

    // load modal popup upon route detail/trip planner result page load
    // if (jQuery('#mailchimpModal').length > 0) {
    //   jQuery('#mailchimpModal').modal('show');
    // }

  }
}
</script>
<style lang="scss" scoped>
@import '../sass/_variables.scss'; // must be disabled when building for production

#route-details-map, #route-details-street-view {
  min-height: 200px;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background-color: #ccc;
}

.circle-route-no {
  font-size: 20px;
  margin-left: 10px;
  margin-top: -10px;
}

.url-links .btn {
  width: 300px;
  margin-top: 10px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/RouteDetails.vue